import React, {useState, useEffect } from 'react'
import {
    FormControl,
    FormLabel,
    Input as ChakraInput,
    Text, InputGroup, InputLeftElement,
    FormErrorMessage,
    InputRightElement,
  } from "@chakra-ui/react"
  import { Icon } from '.';
import MaskInput from "react-maskinput"
import Flag from "react-world-flags";
import { parsePhoneNumber } from "libphonenumber-js";

const formatNumber = (number) => {
    try{        
        let phoneNumber = parsePhoneNumber(number)        
        if(phoneNumber){        
            if(!phoneNumber?.country){                
                let code = phoneNumber?.countryCallingCode;                
                let country = phoneNumber?.metadata?.country_calling_codes[code][0];
                phoneNumber['country'] = country
            }
            return phoneNumber;
        }
    }catch(e){
        return null
        // console.log("Error", e)
    }
}
export const PhoneInput = React.forwardRef( ({error, info, mask, value, clearable, required=false, onClear,  size, label, ...props}, ref) => {
    
    const [ country, setCountry] = useState('PK')    

    useEffect(() => {
        if(value){
            let formatted = formatNumber(value)                
            setCountry(formatted?.country || 'PK');
            // onChange(value)
        }
    }, [value])


    

    return(
        <FormControl isInvalid={error}>
            {label && <FormLabel fontSize="12px" color="gray.400" fontWeight="600" textTransform="uppercase">{label} {required && <Text as={'span'} m="0" fontSize="xs" color="red">*</Text>}</FormLabel>}
            {
                info &&
                <Text mt="0"   color="gray.500" fontSize="sm">{info}</Text>
            }
            <InputGroup size={size || 'md'}>
                
                <InputLeftElement>
                    <Flag height="16px" width="24px" code={country} />
                </InputLeftElement>                
                <ChakraInput                     
                    as={MaskInput}
                    maskChar="_"                     
                    value={value || '+92'}
                    mask="+000000000000"
                    {...props} 
                    ref={ref} 
                />       
                {
                    (clearable && value) &&
                    <InputRightElement onClick={() => onClear()}>
                        <Icon  name="ios-close-circle" fontSize="20px" position="relative" top="-1.5" />
                    </InputRightElement>
                }
            </InputGroup>
            <FormErrorMessage>{error}</FormErrorMessage>
        </FormControl>
    )
})